import { render } from "./WechatScheduled.vue?vue&type=template&id=5d1815bc&scoped=true"
import script from "./WechatScheduled.vue?vue&type=script&lang=js"
export * from "./WechatScheduled.vue?vue&type=script&lang=js"

import "./WechatScheduled.vue?vue&type=style&index=0&id=5d1815bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1815bc"]])

export default __exports__